import { CollectionFieldAdapter } from '../../components/experience/forms/CollectionFieldAdapter';
import { registerFieldAdapter } from './field-adapters';

registerFieldAdapter({
  fieldType: 'collection',
  component: CollectionFieldAdapter,
});
